"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateInvoiceFromClientDto = exports.SimpleInvoiceSlotDto = exports.SimpleInvoiceDto = exports.InvoiceCartDto = exports.UpdateInvoiceDto = exports.UpdateInvoiceOptionsDto = exports.BaseInvoiceDto = exports.InvoiceDto = void 0;
const organization_dto_1 = require("../../organization/dto/organization.dto");
class InvoiceDto {
}
exports.InvoiceDto = InvoiceDto;
class BaseInvoiceDto {
}
exports.BaseInvoiceDto = BaseInvoiceDto;
class UpdateInvoiceOptionsDto {
}
exports.UpdateInvoiceOptionsDto = UpdateInvoiceOptionsDto;
class UpdateInvoiceDto extends UpdateInvoiceOptionsDto {
}
exports.UpdateInvoiceDto = UpdateInvoiceDto;
class InvoiceCartDto {
}
exports.InvoiceCartDto = InvoiceCartDto;
class SimpleInvoiceDto extends organization_dto_1.OrganizationBaseEntityDto {
}
exports.SimpleInvoiceDto = SimpleInvoiceDto;
class SimpleInvoiceSlotDto {
}
exports.SimpleInvoiceSlotDto = SimpleInvoiceSlotDto;
/**
 * DTO for updating invoices from client-side requests.
 * This DTO defines the specific fields that are safe to update from client applications.
 * All other fields are restricted for security and data integrity reasons.
 */
class UpdateInvoiceFromClientDto {
}
exports.UpdateInvoiceFromClientDto = UpdateInvoiceFromClientDto;
//# sourceMappingURL=invoice.dto.js.map